<div class="audit-list-container" style="padding-bottom: var(--footer-height, 56px); box-sizing: border-box;">
  <div class="flex justify-content-end mt-3">
    <div>
      <div class="total">
        Total Type of Changes({{ typeOfChangesTotalRecords }})
      </div>
    </div>
    <div class="filter-action-row">
      <button pButton type="button" label="Save" class="" (click)="Add()">
        Add
      </button>
    </div>
  </div>
  <app-table
    [data]="typeOfChangesData"
    [columns]="typeOfChangesColumns"
    [rows]="typeOfChangesPageSize"
    [showPaginator]="true"
    [showSort]="false"
    [showFilter]="false"
    [loading]="typeOfChangesLoading"
    [globalFilterFields]="typeOfChangesGlobalFilterFields"
    [actions]="typeOfChangesActions"
    [totalRecords]="typeOfChangesTotalRecords"
    [hideTableHeader]="true"
    (lazyLoadData)="onLazyLoadEventFromTable($event)"
  >
  </app-table>
</div>

<app-add-type-of-changes
  [visible]="openModal"
  [data]="editData"
  (closeDialog)="closeDialog($event)"
  [editMode]="editMode"
></app-add-type-of-changes>
